export default {
  component: () => import('./page.vue'),
  path: '/message-config',
  name: 'message-config',
  meta: {
    title: '消息信息',
    auth: true,
  },
};
